module.exports = __webpack_public_path__ + "img/emoji_12.a3799743.png";